import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter, Mutation } from 'vuex-class'
import moment from 'moment'

import ApiRequest from '@/core/ApiRequest'
import CallModel from '@/core/models/Call'
import RoomModel, { TABLES_ALL } from '@/core/models/Room'
import ResponseModel from '@/core/models/ResponseModel'
import { ADD_CALL_ITEM, FETCH_ROOMS_LIST } from '@/store/root/actions'
import { GET_API_REQUEST, GET_ROOMS_LIST } from '@/store/root/getters'


@Component
export default class Call extends Vue {
  public snackbarTimeout = 1750
  public snackbarText = ''
  public snackbarShown = false

  private DISPLAY_DATE_FORMAT = 'DD-MM-YYYY'
  public room: RoomModel | null = null;
  public tableNumbers: Array<string> = [];
  public options: Array<{ name: string, amount: string }> = [];
  public optionsItems: Array<string> = ['Фуршет', 'Выездная церемония', 'Выездная церемония перед главным залом', 'Оформление зала и президиума', 'Оформление президиума', 'Буквы имен молодоженов', 'Схема рассадки гостей', 'Селфи зеркало', 'Другое']; // todo: move to const
  public dateFrom: string = '';
  public dateTo: string = '';
  public timeFrom: any = '10:00';
  public timeTo: any = '23:00';
  public eventType: string = '';
  public pricePerPerson: string = '';
  public persons: string = '';
  public files: any = [];
  public attachmentLoading = false;
  public isConfirmDialogShown = false;
  public warningMessages: Array<string> = [];

  public contacts: Array<{ name: string, phone: string }> = [
    { name: '', phone: '' },
    { name: '', phone: '' },
    { name: '', phone: '' },
    { name: '', phone: '' },
    { name: '', phone: '' },
  ];

  public managerComments: any = '';

  public dateFromMenu = false;
  public timeFromMenu = false;
  public dateToMenu = false;
  public timeToMenu = false;
  public statusConfirmationDateMenu = false;
  public errorMessage: string | null = '';
  public errorMessagePhones: Array<string | null> = ['', '', '', '', ''];
  public isLoading = false;
  public callIsFetched = false;
  public canEdit = false;

  public date: string = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000))
    .toISOString().substr(0, 10);

  /**
   * Property that indicates ID of shown event.
   */
  @Prop({ default: null })
  public id: string | null;

  /**
   * Property that indicates is edit mode enabled.
   */
  @Prop({ default: true })
  public editable: boolean;

  /**
   * Fetch rooms list.
   */
  @Action(FETCH_ROOMS_LIST)
  public fetchRoomsList:
    () => void;

  /**
   * Add call item.
   */
  @Action(ADD_CALL_ITEM)
  public addCallItem:
    /**
     * @param payload      Payload with event to add.
     *
     * @return   Resolved promise.
     */
    (payload: { call: CallModel, forced: boolean | null }) => Promise<ResponseModel>

  /**
   * Get api request object, based on global Vuex state.
   */
  @Getter(GET_API_REQUEST)
  public getApiRequest: ApiRequest

  /**
   * Get rooms list, based on global Vuex state.
   */
  @Getter(GET_ROOMS_LIST)
  public getRoomsList: RoomModel[];

  /**
   * Room ID getter.
   */
  public get roomId (): string | null {
    return this.room
      ? this.room.id
      : null
  }

  /**
   * Room ID setter.
   */
  public set roomId (value: string | null) {
    this.room = this.getRoomsList.find((room) => room.id === value) || null
    this.tableNumbers = [TABLES_ALL]
  }

  /**
   * Returns list of tables for current room.
   */
  public getTablesList () {
    if (this.room === null) {
      return []
    }
    const tables: Array<string> = Array.from(
      { length: this.room.tables_count },
      (_, i) => String(i + 1))
    tables.unshift(TABLES_ALL)
    return tables
  }

  /**
   * Returns event types list.
   */
  public getEventTypes () { // TODO: move to Event core, may be same as statuses
    return [
      'Свадьба',
      'Сватовство',
      'День рождения',
      'Крестины',
      'Юбилей',
      'Выпускной',
      'Стодневка',
      'Встреча одноклассников',
      'Корпоратив',
      'Конференция',
      'Выставка',
      'Показ',
      'Концерт',
      'Нишан',
      'Бешик-той',
      'Дуа',
      'Ифтар',
      'Поминки',
      'Другое',
      'Служебное: ремонт',
    ]
  }

  /**
   * Allowed step for time picker.
   *
   * @param min
   */
  public timePickerAllowedStep (min: number) {
    return min % 5 === 0
  }

  public onDateFromChange (value: string) {
    this.dateFromMenu = false
    // console.log(`onDateFromChange(${value})`)
    if (this.dateTo === '' || this.dateTo < this.dateFrom) {
      this.dateTo = value
    }
  }

  public addOptionRow () {
    this.options.push({ name: '', amount: '' })
  }

  public removeOptionRow (index: number) {
    if (index > 0) {
      this.options.splice(index, 1)
    } else {
      if (this.options.length > 1) { // exists yet rows
        this.options.splice(index, 1)
      } else {
        this.options[0] = { name: '', amount: '' }
      }
    }
  }

  public addContactRow () {
    this.contacts.push({ name: '', phone: '' })
  }

  public removeContactRow (index: number) {
    if (index > 0) {
      this.contacts.splice(index, 1)
    } else {
      if (this.contacts.length > 1) { // exists yet rows
        this.contacts.splice(index, 1)
      } else {
        this.contacts[0] = { name: '', phone: '' }
      }
    }
  }

  public copyPhone (index: number) {
    try {
      navigator.clipboard.writeText(this.contacts[index].phone)
      this.snackbarText = 'Номер скопирован'
      this.snackbarShown = true
    } catch (e) {
      console.log('Error no copy phone', e.message)
    }
  }

  public onPhoneInput (formattedNumber: string, options: any, index: number) {
    const { number, valid, country } = options
    this.contacts[index].phone = number.international
    if (!this.callIsFetched) {
      this.errorMessagePhones[index] = null
      return
    }

    this.errorMessagePhones[index] = valid
      ? null
      : 'Номер указан неверно'
  }

  /**
   * Form submit handler.
   */
  public async formSubmit (forced: boolean) {
    this.errorMessage = ''

    // todo: move to vue-validate rules
    if (!this.room) {
      this.errorMessage = 'Ошибка: не указан зал!'
      return
    }

    if (this.pricePerPerson && !Number.parseInt(this.pricePerPerson)) {
      this.errorMessage = 'Ошибка: некорректная цена за человека!'
      return
    }

    if (this.persons && !Number.parseInt(this.persons)) {
      this.errorMessage = 'Ошибка: некорректное количество человек!'
      return
    }

    let validationError
    validationError = this.validateDates()
    validationError = validationError || this.validateContacts()
    if (validationError) {
      this.errorMessage = validationError
      return
    }

    const call = new CallModel()
    if (this.id) {
      call.id = this.id
    }
    call.room_id = this.room?.id
    call.table_numbers = this.tableNumbers.includes(TABLES_ALL)
      ? 'all'
      : this.tableNumbers.join(',')

    call.contacts = []
    for (const [index, contact] of this.contacts.entries()) {
      if (index > 0 && !contact.name && !contact.phone) { continue }
      call.contacts.push(contact)
    }

    call.options = []
    for (const [index, option] of this.options.entries()) {
      if (!option.name) { continue }
      call.options.push(option)
    }
    call.options = call.options.length > 0 ? call.options : null

    call.type = this.eventType
    call.date_from = (new Date(this.dateFrom + 'T' + this.timeFrom)).toISOString()
    call.date_to = (new Date(this.dateTo + 'T' + this.timeTo)).toISOString()
    call.manager_comments = this.managerComments
    call.price_per_person = Number.parseInt(this.pricePerPerson) ? +this.pricePerPerson : null
    call.persons = Number.parseInt(this.persons) ? +this.persons : null


    this.isLoading = true
    try {
      const result = await this.addCallItem({ call, forced })
      this.isLoading = false
      if (result?.data?.warnings) {
        this.isConfirmDialogShown = true
        this.warningMessages = result.data.warnings
        return
      }

      // if (!this.id) {
      // console.log('goto home', moment(call.date_from).format('YYYY-MM-DD'))
      this.$router.push({
        name: 'dayEvents',
        params: { date: moment(call.date_from).format('YYYY-MM-DD') },
      })
      // } else {
      //   console.log('goto self')
      //   this.$router.go(0)
      // }
    } catch (error) {
      this.isLoading = false
      this.isConfirmDialogShown = true
      if (error.error && error.error !== 'Overbooking') {
        this.warningMessages = [error.error]
      } else {
        this.warningMessages = ['На указанную дату данные столы уже забронированы. Продолжить?']
      }
    }
  }

  private validateDates (): string | null {
    if (!this.dateFrom || this.dateFrom === '') {
      return 'Ошибка: не указана дата начала бронирования!'
    }
    if (!this.dateTo || this.dateTo === '') {
      return 'Ошибка: не указана дата окончания бронирования!'
    }

    return null
  }

  private validateContacts (): string | null {
    for (const [index, contact] of this.contacts.entries()) {
      if (index > 0 && !contact.name && !contact.phone) {
        continue
      }

      if (!contact.name) {
        return `Ошибка: не указано имя ${index > 0 ? 'контакта ' + (index + 1).toString() : 'клиента'}!`
      }
      if (!contact.phone) {
        return `Ошибка: не указан телефон ${index > 0 ? 'контакта ' + (index + 1).toString() : 'клиента'}!`
      }
    }
    return null
  }

  /**
   * Fetch current call and fill component inputs.
   */
  public async fetchCurrentCall () {
    const response = await this.getApiRequest.send(
      'GET',
      'calls/' + encodeURIComponent(this.id!),
    )
    if (!response || !response.data) { return }

    const call = response.data
    console.log(call)
    this.callIsFetched = true
    this.room = this.getRoomsList.find((room) => room.id === call.room_id) || null
    const tableItems = call.table_numbers.split(',')
    this.tableNumbers = tableItems.includes('all') ? [TABLES_ALL] : tableItems

    this.contacts = [{
      name: call.contact_name,
      phone: call.contact_phone,
    }]
    this.options = call.options && call.options.length > 0 ? call.options : [{ name: '', amount: '' }]
    this.eventType = call.type
    this.pricePerPerson = Number.parseInt(call.price_per_person) ? `${call.price_per_person}` : ''
    this.persons = Number.parseInt(call.persons) ? `${call.persons}` : ''

    const dateFrom = new Date(call.date_from)
    const dateTo = new Date(call.date_to)
    this.dateFrom = moment(dateFrom.toISOString()).format('YYYY-MM-DD')
    this.dateTo = moment(dateTo.toISOString()).format('YYYY-MM-DD')
    this.timeFrom = dateFrom.toLocaleTimeString()
    this.timeTo = dateTo.toLocaleTimeString()

    this.managerComments = call.manager_comments
  }

  public addForced () {
    this.isConfirmDialogShown = false
    this.formSubmit(true)
  }

  @Watch('tableNumbers')
  public onShownChanged (value: Array<string>, oldvalue: Array<string>) {
    if (value.includes(TABLES_ALL) && value.length > 1) {
      if (!oldvalue.includes(TABLES_ALL)) {
        this.tableNumbers = [TABLES_ALL]
      } else {
        this.tableNumbers = this.tableNumbers.filter(tableName => tableName !== TABLES_ALL)
      }
    }
  }

  public formattedDateTo (): string {
    return moment(this.dateTo).format(this.DISPLAY_DATE_FORMAT)
  }

  public formattedDateFrom (): string {
    return moment(this.dateFrom).format(this.DISPLAY_DATE_FORMAT)
  }

  public callPhone (phone: string) {
    window.location.href = `tel:${phone}`
  }

  /**
   * Created lifecycle hook. Fires when component instance is created.
   */
  public async mounted () {
    if (this.canEdit && !this.id) { // Add new event
      this.callIsFetched = true
      this.contacts = [{ name: '', phone: '' }]
      this.options = [{ name: '', amount: '' }]
    }
  }

  /**
   * Created lifecycle hook. Fires when component instance is created.
   */
  public async created () {
    this.canEdit = this.editable
    await this.fetchRoomsList()
    if (this.id) {
      await this.fetchCurrentCall()
    }

    if (this.canEdit && !this.id) { // Add new event
      this.callIsFetched = true
      if (this.$route.query.date) {
        const date = new Date(this.$route.query.date as string)
        this.dateFrom = moment(date.toISOString()).format('YYYY-MM-DD')
        this.dateTo = moment(date.toISOString()).format('YYYY-MM-DD')
      }
    }
  }
}
